import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Tab from '../../tabs/tabs';
import ActivityBillings from './activityBillings/ActivityBillings';
import ActivityPayouts from './activityPayouts/ActivityPayouts';

const OrgActivityBillings = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('Billing');

    useEffect(() => {
        if (location.pathname.startsWith('/org/a/payouts')) {
            setActiveTab('Payouts');
        } else {
            setActiveTab('Billing');
        }
    }, [location.pathname]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        navigate(
            tab === 'Billing' ? '/org/a/billing?status=completed&approval=approved&page=1' : '/org/a/payouts?page=1'
        );
    };

    return (
        <>
            <div className='tabContainer bookingSticky'>
                <Tab label='Billing' value={'Billing'} activeTab={activeTab} setActiveTab={handleTabChange} />
                <Tab label='Payouts' value={'Payouts'} activeTab={activeTab} setActiveTab={handleTabChange} />
            </div>
            <div>
                {activeTab === 'Billing' && <ActivityBillings />}
                {activeTab === 'Payouts' && <ActivityPayouts />}
            </div>
        </>
    );
};

export default OrgActivityBillings;
